export const validWalletMoney = value => (typeof value === 'number' || typeof value === 'string')
    && String(value).trim() !== '' && Number.isSafeInteger(Number(value)) && Number(value) >= 0;

export function walletTransferOutcome(code) {
    if (code === 1000) return { complete: true, terminal: true, message: '송금이 완료되었습니다.' };
    if (code === 1002) return { complete: false, terminal: true, message: '송금에 실패했습니다.' };
    if (code === 1001) return { complete: false, terminal: false, message: '송금 처리 중입니다.' };
    if (code === 1003) return { complete: false, terminal: false, message: '송금 결과 확인 대기 중입니다.' };
    return { complete: false, terminal: false, message: '송금 결과를 확인하지 못했습니다.' };
}

// The GET envelope's code is never a withdrawal outcome.
export function storedWalletOutcome(record) {
    const result = record?.result;
    if (record?.status === 'SUCCESS' && result?.code === 1000) return walletTransferOutcome(1000);
    if (['FAILED', 'REJECTED'].includes(record?.status) && Number.isInteger(result?.code) && ![1000, 1001, 1003].includes(result.code)) {
        return { ...walletTransferOutcome(1002), message: result?.msg || '송금 요청이 거절되었거나 실패했습니다.' };
    }
    return { complete: false, terminal: false, message:
        record?.status === 'VALIDATING' ? '송금 요청을 확인 중입니다.' :
        record?.status === 'UNKNOWN' ? '송금 결과 확인 대기 중입니다. 관리자 확인이 필요할 수 있습니다.' :
        record?.status === 'PENDING' ? '송금 처리 중입니다.' : '송금 결과를 확인하지 못했습니다.' };
}

export function walletRequestRows(response) {
    if (response?.code !== 1000 || !Array.isArray(response?.data?.requests)) throw new Error(response?.msg || '송금 요청을 조회하지 못했습니다.');
    return response.data.requests;
}

export const pendingWalletKey = (api, mid) => mid ? `fast-wallet-pending:${api}:${mid}` : null;
export function readPendingWallet(key) {
    if (!key) throw new Error('가맹점 정보를 확인하지 못했습니다.');
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (typeof data?.requestId !== 'string' || !data.requestId) throw new Error('송금 요청 정보를 확인하지 못했습니다.');
    return data;
}

export const walletTransactionStatus = status => status === 'FP_PENDING' ? '처리 중' : status;

